/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Tag } from "./Tag";
import { TagFromJSON, TagFromJSONTyped, TagToJSON } from "./Tag";

export interface TagDataResponse {
  data: Tag;
}

export function TagDataResponseFromJSON(json: any): TagDataResponse {
  return TagDataResponseFromJSONTyped(json);
}

export function TagDataResponseFromJSONTyped(json: any): TagDataResponse {
  if (json == null) {
    return json;
  }

  return {
    data: TagFromJSON(json["data"]),
  };
}

export function TagDataResponseToJSON(
  value: TagDataResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: TagToJSON(value.data),
  };
}
